module.exports = __webpack_public_path__ + "img/logo-MM-PDE-transparente.6e95f91c.png";